import { Info, Warning, SealWarning } from "@phosphor-icons/react";

const STATUS_MAP = {
  compliant: { label: "Compliant", fg: "#40593B", bg: "#EDF2EB", Icon: null },
  pending: { label: "Pending review", fg: "#F29F05", bg: "#FDF4E6", Icon: Info },
  needs_upgrade: { label: "Needs upgradation", fg: "#D93636", bg: "#FBEAE9", Icon: Warning },
  restricted: { label: "Restricted", fg: "#8C1D1D", bg: "#FBEAE9", Icon: SealWarning },
};

export default function RegulatoryPanel({ statusByRegion = {} }) {
  const entries = Object.entries(statusByRegion);
  if (entries.length === 0) return null;

  const needsCount = entries.filter(([, s]) => s === "needs_upgrade").length;

  return (
    <section
      data-testid="regulatory-panel"
      className="mt-10 border border-[#E5E2DC] bg-white"
    >
      <div className="p-6 md:p-8 border-b border-[#E5E2DC]">
        <div className="flex items-end justify-between flex-wrap gap-3">
          <div>
            <div className="eyebrow">Regulatory compliance</div>
            <h2 className="font-heading text-2xl sm:text-3xl font-medium mt-1">
              Region-by-region status
            </h2>
          </div>
          {needsCount > 0 ? (
            <div
              className="text-[11px] uppercase tracking-[0.18em] font-semibold px-2.5 py-1"
              style={{ background: "#FBEAE9", color: "#D93636" }}
            >
              {needsCount} region{needsCount > 1 ? "s" : ""} need upgradation
            </div>
          ) : (
            <div
              className="text-[11px] uppercase tracking-[0.18em] font-semibold px-2.5 py-1"
              style={{ background: "#EDF2EB", color: "#40593B" }}
            >
              Fully compliant
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-px bg-[#E5E2DC]">
        {entries.map(([region, status]) => {
          const s = STATUS_MAP[status] || STATUS_MAP.pending;
          return (
            <div
              key={region}
              data-testid={`reg-${region}`}
              className="bg-white p-4 flex flex-col gap-2"
            >
              <div className="eyebrow">{region}</div>
              <div
                className="text-[11px] uppercase tracking-[0.14em] font-semibold px-2 py-1 inline-flex items-center gap-1 self-start"
                style={{ background: s.bg, color: s.fg }}
              >
                {s.Icon ? <s.Icon size={11} weight="bold" /> : null}
                {s.label}
              </div>
            </div>
          );
        })}
      </div>

      <div className="px-6 md:px-8 py-3 border-t border-[#E5E2DC] text-[11px] text-[#6E6B65] leading-snug">
        Status inferred from formulation vs. region-specific rules (EU Annex II/III, UK COSMOS,
        India BIS, GCC GSO 1943, China NMPA, Korea KCA). Not a substitute for formal dossier review.
      </div>
    </section>
  );
}
